import { addSurveyAnswers } from "@utils/redux/slices/surveyAnswers";
import { updateCurrentAnswers } from "src/utils/redux/slices/currentAnswers";
import { getPageSetSurvey } from "./util";
import { ActionHandlerParams } from "..";
import { getSurveyAnswers } from "src/hooks/survey/answers";
import { prepareAndTrackSurveyAnswers } from "src/utils/mainSurvey";

const questionId = "mostImportantGoal";

export const autoSetMostImportantGoal = ({
  store,
  pageSet,
  page,
}: ActionHandlerParams): void => {
  const survey = getPageSetSurvey(pageSet, page);
  const { goal } = getSurveyAnswers();

  if (goal && Array.isArray(goal) && goal.length === 1) {
    const singleGoal = goal[0];

    store.dispatch(
      addSurveyAnswers({
        [questionId]: [singleGoal],
      })
    );

    store.dispatch(
      updateCurrentAnswers({
        namespace: survey.surveyNameSpace,
        answers: {
          [questionId]: [singleGoal],
        },
      })
    );

    // Track the answer to Mixpanel - need fresh call after dispatch to get updated state
    const surveyAnswers = getSurveyAnswers();
    prepareAndTrackSurveyAnswers(questionId, surveyAnswers);
  }
};
